import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/auth.slice'
import { authServiceApi } from './apis/auth.service.api'
import { classServiceApi } from './apis/class.service.api'
import { moduleServiceApi } from './apis/module.service.api'
import { subjectServiceApi } from './apis/subject.service.api'
import { questionServiceApi } from './apis/question.service.api'
import { answerServiceApi } from './apis/answer.service.api'
import { lessonServiceApi } from './apis/lesson.service.api'
import { schoolLevelServiceApi } from './apis/school-level.service.api'
import { rulesApi } from './apis/rule.service.api'
import { dashboardApi } from './apis/dashboard.service.api'
import { userServiceApi } from './apis/user.service.api'
import { profileServiceApi } from './apis/profile.service.api'
import { groupServiceApi } from './apis/group.service.api'
import { sessionServiceApi } from './apis/session.service.api'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [classServiceApi.reducerPath]: classServiceApi.reducer,
    [moduleServiceApi.reducerPath]: moduleServiceApi.reducer,
    [subjectServiceApi.reducerPath]: subjectServiceApi.reducer,
    [questionServiceApi.reducerPath]: questionServiceApi.reducer,
    [answerServiceApi.reducerPath]: answerServiceApi.reducer,
    [lessonServiceApi.reducerPath]: lessonServiceApi.reducer,
    [schoolLevelServiceApi.reducerPath]: schoolLevelServiceApi.reducer,
    [rulesApi.reducerPath]: rulesApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [userServiceApi.reducerPath]: userServiceApi.reducer,
    [profileServiceApi.reducerPath]: profileServiceApi.reducer,
    [groupServiceApi.reducerPath]: groupServiceApi.reducer,
    [sessionServiceApi.reducerPath]: sessionServiceApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authServiceApi.middleware,
      classServiceApi.middleware,
      moduleServiceApi.middleware,
      subjectServiceApi.middleware,
      questionServiceApi.middleware,
      answerServiceApi.middleware,
      lessonServiceApi.middleware,
      schoolLevelServiceApi.middleware,
      rulesApi.middleware,
      dashboardApi.middleware,
      userServiceApi.middleware,
      profileServiceApi.middleware,
      groupServiceApi.middleware,
      sessionServiceApi.middleware,
    ]),
})
